import messageResource from '../messageResource'
import ListSelector from './ListSelector'
import Ext from 'Ext'
import {DEFAULT_TIME_ZONE_GROUP_ID} from 'constants'
import {formatRawSecondsOffset} from '../atUtils'

const TimeZoneGroupsListSelector = Ext.extend(ListSelector, {

    rawOffsetPropName: "rawOffset",

    createItem: function(listItem)
    {
        var item = TimeZoneGroupsListSelector.superclass.createItem.call(this, listItem);
        var rawOffset = listItem[this.rawOffsetPropName];

        if (rawOffset || rawOffset === 0)
        {
            var text = item.text;
            var title = text;

            if(item.value == DEFAULT_TIME_ZONE_GROUP_ID) {
                var groupNote = messageResource.getMessage("users_selector.default_group");
                text = "<span class='defaultGroupName'>" + text+"</span>" +
                       "<span class='defaultGroupNote'>"+ groupNote +"</span>";
            }

            item.text = "<div class='timeZoneOffset'>" + messageResource.getMessage("time_zones_selector.js.gmt", [formatRawSecondsOffset(rawOffset)])
                        + "</div><div class='timeZoneGroupName' title='"+title+"'>" + text + "</div>";
        }

        return item;
    }

});

export default TimeZoneGroupsListSelector



// WEBPACK FOOTER //
// ./web/js/controls/TimeZoneGroupsListSelector.js